import { AfterViewInit, Component, ElementRef, Inject, Input, Optional, Renderer2, SkipSelf, ViewChild } from '@angular/core';

import { BehaviorSubject } from 'rxjs';
import { first } from 'rxjs/operators';

import { UiSdgIconsList } from '../../model/ui-icons.model';
import { UiSdgIconsService } from '../../services/ui-sdg-icons.service';
import { UI_ICONS_LANGUAGE_TOKEN } from '../../tokens/ui-icon-language.token';

@Component({
  selector: 'ui-sdg-icon',
  templateUrl: './sdg-icon.component.html',
  styleUrl: './sdg-icon.component.scss',
  standalone: false
})
export class SdgIconComponent implements AfterViewInit {
  @Input() key: UiSdgIconsList | undefined = undefined;
  @Input() tooltipPosition: 'top' | 'bottom' = 'top';
  @Input({ required: false }) language?: string;

  @ViewChild('container') container: ElementRef | null = null;

  supportedLanguageList = [
    'sk',
    'cz',
    'pl',
    'de',
    'en',
    'ar'
  ];

  constructor(
    private smartheadIconsService: UiSdgIconsService,
    private renderer: Renderer2,
    @SkipSelf() @Optional() @Inject(UI_ICONS_LANGUAGE_TOKEN) private language$: BehaviorSubject<string>
  ) {}

  ngAfterViewInit(): void {
    this.smartheadIconsService
      .getIconContent(this.key as UiSdgIconsList, this.#getLanguage())
      .pipe(first())
      .subscribe(iconContent => {
        this.renderer.setProperty(this.container?.nativeElement, 'innerHTML', iconContent);
      });
  }

  #getLanguage() {
    const language = this.language$?.value ?? this.language;
    if (this.supportedLanguageList.includes(language)) {
      return language;
    }
    return 'en';
  }
}
